import * as React from 'react';
import { InfoBar } from 'owa-info-bar-view';
import { ComposeViewState } from 'owa-mail-compose-store';
import { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import getInfoBarMessageViewState from '../utils/getInfoBarMessageViewState';
import { getMailTipMessageViewStates } from 'owa-mail-tips';
import getMailTips from 'owa-mail-tips/lib/selectors/getMailTips';
import { getAllRecipients } from 'owa-mail-compose-actions/lib/utils/getAllRecipientsAsEmailAddressStrings';
import getCurrentFromAddress from 'owa-mail-compose-actions/lib/utils/getFromAddressFromRecipientWell';
import onRemoveRecipientFromMailTip from 'owa-mail-compose-actions/lib/actions/onRemoveRecipientFromMailTip';
import { lazyOpenChecker } from 'owa-editor-acc-checker-plugin';
import { observer } from 'mobx-react-lite';
import ProjectionContext from 'owa-popout-v2/lib/context/ProjectionContext';

const styles = require('./ComposeInfoBar.scss');

export interface ComposeInfoBarProps {
    viewState: ComposeViewState;
}

export default observer(function ComposeInfoBar(props: ComposeInfoBarProps) {
    const targetWindow = React.useContext(ProjectionContext);
    const messages: InfoBarMessageViewState[] = [];
    const { viewState } = props;
    const { infoBarIds, ccRecipientWell } = viewState;

    for (const messageId of infoBarIds) {
        const message: InfoBarMessageViewState = getInfoBarMessageViewState(
            messageId,
            viewState,
            targetWindow
        );
        if (message) {
            messages.push(message);
        }
    }

    const fromAddress: string = getCurrentFromAddress(ccRecipientWell);

    const mailTipMessages = getMailTipMessageViewStates(
        getAllRecipients(viewState),
        getMailTips(),
        fromAddress,
        recipients => onRemoveRecipientFromMailTip(viewState, recipients),
        () =>
            lazyOpenChecker
                .import()
                .then(openChecker => openChecker(viewState.accChecker, viewState, targetWindow))
    );

    return (
        <InfoBar
            messages={[...messages, ...mailTipMessages]}
            textContainerClassName={styles.infoBarTextContainer}
            className={styles.infoBar}
        />
    );
});
